<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{ current()?.title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if (queue.length > 1) {
    <ion-note>{{ 'wizard.step' | translate }} {{ index() + 1 }} {{ 'wizard.of' | translate }} {{ queue.length }}</ion-note>
  }
  @if (current(); as step) {
    <ng-container *ngComponentOutlet="step.component; injector: stepInjector" />
  }
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding">
    <div class="navigation" [class.with-back]="index() > 0">
      @if (index() > 0) {
        <ion-button fill="outline" (click)="goBack()">
          <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
          {{ 'core.backButton' | translate }}
        </ion-button>
      }
      <ion-button (click)="advance()">
        {{ (isLast() ? 'core.done' : 'wizard.next') | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
